import React from 'react'
import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import { useTranslation } from 'react-i18next'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'

const LegalNotices = () => {
  const { t } = useTranslation()

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle title={t('LEGAL_NOTICES')} description="" />

      <div className="container section py-4">
        <h2>Informations légales</h2>
        <ul>
          <li>
            <strong>Propriétaire</strong> : Kubuni
          </li>
          <li>
            <strong>Siret</strong> : 818119034
          </li>
          <li>
            <strong>RCS</strong> : Toulouse B 818 119 034
          </li>
          <li>
            <strong>APE</strong> : 6311Z
          </li>
        </ul>

        <hr />

        <h2>Hébergement</h2>
        <ul>
          <li>
            <strong>Hébergeur</strong> : OVH
          </li>
          <li>
            <strong>Adresse</strong> : 2 rue Kellermann, 59100 Roubaix, France
          </li>
          <li>
            <strong>Téléphone</strong> : +33 9 72 10 10 07
          </li>
          <li>
            <strong>Email</strong> :{' '}
            <a href="https://www.ovhcloud.com/fr/contact/">Contacter OVH</a>
          </li>
          <li>
            <strong>Site web</strong> :{' '}
            <a href="https://www.ovhcloud.com/fr/">OVHcloud</a>
          </li>
        </ul>

        <hr />

        <h2>Directeur de la publication</h2>
        <ul>
          <li>
            <strong>Nom</strong> : DUPUY Régis
          </li>
          <li>
            <strong>Fonction</strong> : Gérant
          </li>
        </ul>

        <hr />

        <h2>Propriété intellectuelle</h2>
        <p>
          Le contenu du site www.revesdebarousse.fr est protégé par les droits
          de propriété intellectuelle du Propriétaire. Toute reproduction,
          représentation, modification, publication, adaptation de tout ou
          partie des éléments du site, quel que soit le moyen ou le procédé
          utilisé, est interdite, sauf autorisation écrite et préalable du
          Propriétaire.
        </p>

        <hr />

        <h2>Responsabilité</h2>
        <p>
          Le Propriétaire ne peut être tenu responsable des dommages directs ou
          indirects, matériels ou immatériels, causés par l'utilisation du site
          www.revesdebarousse.fr.
        </p>

        <hr />

        <h2>Liens hypertextes</h2>
        <p>
          Le site www.revesdebarousse.fr peut contenir des liens hypertextes
          vers d'autres sites web. Le Propriétaire ne peut être tenu responsable
          du contenu de ces sites web.
        </p>

        <hr />

        <h2>Collecte de données personnelles</h2>
        <p>
          Le Propriétaire collecte des données personnelles lors de
          l'inscription de l'Utilisateur, de la passation d'une commande et de
          la navigation sur le Site.
        </p>
        <p>
          Les données collectées sont les suivantes : nom, prénom, adresse
          email, adresse postale, numéro de téléphone, données de connexion et
          de navigation.
        </p>
        <p>
          Le Propriétaire s'engage à ne pas transmettre les données collectées à
          des tiers sans le consentement de l'Utilisateur.
        </p>
        <p>
          L'Utilisateur dispose d'un droit d'accès, de rectification, de
          suppression et d'opposition aux données le concernant.
        </p>

        <hr />

        <h2>Cookies</h2>
        <p>
          Le Site utilise des cookies pour améliorer l'expérience utilisateur et
          à des fins de statistiques.
        </p>
        <p>L'Utilisateur peut accepter ou refuser l'utilisation des cookies.</p>
        <p>
          L'Utilisateur peut paramétrer son navigateur pour refuser
          l'installation de cookies.
        </p>

        <hr />

        <h2>Loi applicable et juridiction compétente</h2>
        <p>
          Les présentes mentions légales sont soumises au droit français. En cas
          de litige, les tribunaux français seront seuls compétents.
        </p>

        <hr />

        <h2>Contact</h2>
        <p>
          Pour toute question ou réclamation, l'Utilisateur peut contacter le
          Propriétaire en utilisant le formulaire de contact disponible sur le
          Site.
        </p>
      </div>

      <BottomImage pageName="LEGAL_NOTICES" />

      <Footer />
    </div>
  )
}

export default LegalNotices
